// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19-A3","icon":"styles_icon__1fC18"};